import React from 'react';
import { APP_NAME } from '../utils/config';

type LogoVariant = 'icon' | 'full';

interface LogoProps {
  variant?: LogoVariant;
  className?: string;
  showText?: boolean;
  textClassName?: string;
}

const Logo: React.FC<LogoProps> = ({
  variant = 'icon',
  className = 'h-8 w-8',
  showText = false,
  textClassName = 'text-xl font-bold text-gray-900',
}) => {
  const src = variant === 'full' ? '/logo.png' : '/logo-icon.png';
  const alt = `${APP_NAME} logo`;

  if (showText) {
    return (
      <span className="flex items-center gap-2">
        <img src={src} alt={alt} className={className} />
        <span className={textClassName}>{APP_NAME}</span>
      </span>
    );
  }

  return <img src={src} alt={alt} className={className} />;
};

export default Logo;
